import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateUserByIdMutationVariables = Types.Exact<{
  set?: Types.InputMaybe<Types.Users_Set_Input>;
  id: Types.Scalars['String']['input'];
}>;


export type UpdateUserByIdMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: string, first_name: string, last_name: string, email: string, phone_number?: string | null, profile_photo?: string | null, created_at?: any | null, last_seen?: any | null, is_admin?: boolean | null, role?: string | null, title?: string | null, brief_email_frequency: string, workspace_id?: any | null, organization_id?: any | null, workspace?: { __typename?: 'workspaces', id: any, logo?: string | null, name: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null, display_price?: boolean | null } | null, user_properties: Array<{ __typename?: 'user_properties', id: any, user_id: string, property_id: any, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, premium?: boolean | null, photo_link?: string | null, organization_id: any, workspace_id?: any | null, warranty_start_date?: any | null, warranty_expiration_date?: any | null, warranty_document_id?: any | null, building_type?: string | null, expected_device_type?: any | null, tier_status?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null } | null }>, user_organizations: Array<{ __typename?: 'organizations_users', id: any, organization_id: any, user_id: string, created_at?: any | null, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null }> } | null };


export const UpdateUserByIdDocument = gql`
    mutation updateUserById($set: users_set_input, $id: String!) {
  update_users_by_pk(_set: $set, pk_columns: {id: $id}) {
    id
    first_name
    last_name
    email
    phone_number
    profile_photo
    created_at
    last_seen
    is_admin
    role
    title
    brief_email_frequency
    workspace_id
    workspace {
      id
      logo
      name
    }
    organization_id
    organization {
      id
      name
      type
      organizationImageURL
      display_price
    }
    user_properties {
      id
      user_id
      property_id
      property {
        id
        name
        address
        address_id
        standardized_address {
          id
          street_1
          street_2
          city
          state
          postal_code
          country
        }
        premium
        photo_link
        organization_id
        workspace_id
        warranty_start_date
        warranty_expiration_date
        warranty_document_id
        building_type
        expected_device_type
        tier_status
        organization {
          id
          name
          type
          organizationImageURL
        }
      }
    }
    user_organizations {
      id
      organization_id
      user_id
      created_at
      organization {
        id
        name
        type
        organizationImageURL
      }
    }
  }
}
    `;
export type UpdateUserByIdMutationFn = Apollo.MutationFunction<UpdateUserByIdMutation, UpdateUserByIdMutationVariables>;

/**
 * __useUpdateUserByIdMutation__
 *
 * To run a mutation, you first call `useUpdateUserByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserByIdMutation, { data, loading, error }] = useUpdateUserByIdMutation({
 *   variables: {
 *      set: // value for 'set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateUserByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserByIdMutation, UpdateUserByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserByIdMutation, UpdateUserByIdMutationVariables>(UpdateUserByIdDocument, options);
      }
export type UpdateUserByIdMutationHookResult = ReturnType<typeof useUpdateUserByIdMutation>;
export type UpdateUserByIdMutationResult = Apollo.MutationResult<UpdateUserByIdMutation>;
export type UpdateUserByIdMutationOptions = Apollo.BaseMutationOptions<UpdateUserByIdMutation, UpdateUserByIdMutationVariables>;